import SubmittedFundLaterPage from "./SubmittedFundLaterPage";
export default SubmittedFundLaterPage;
